import { Link } from '@inertiajs/react'
import Seo from '../components/Seo'
import PackCard from '../components/PackCard'
import type { Pack } from '../lib/types'

interface GenreRef { name: string; slug: string }

export default function Catalog({
  packs,
  genre,
  genres,
}: {
  packs: Pack[]
  genre: GenreRef | null
  genres: GenreRef[]
}) {
  const title = genre ? `${genre.name} — Catalog` : 'Catalog'

  return (
    <>
      <Seo
        title={title}
        description="Browse the full Forma Sound catalog of preset and sample packs for Serum 2."
      />

      <section className="mx-auto max-w-[1400px] px-4 sm:px-6 pt-14 pb-8 border-b border-line">
        <div className="mono-label mb-3">Catalog</div>
        <h1 className="text-4xl sm:text-6xl font-semibold tracking-tight">
          {genre ? genre.name : 'Every release'}
        </h1>
        <p className="mt-4 text-muted max-w-xl">
          {packs.length} {packs.length === 1 ? 'pack' : 'packs'} for Serum 2. Built by sound designers, for music producers.
        </p>

        {genres.length > 0 && (
          <div className="mt-6 flex flex-wrap gap-2">
            <Link
              href="/packs"
              className={`mono-label border px-3 py-1.5 transition-colors ${!genre ? 'border-paper text-paper' : 'border-line hover:border-line-2'}`}
            >
              All
            </Link>
            {genres.map((g) => (
              <Link
                key={g.slug}
                href={`/packs/genres/${g.slug}`}
                className={`mono-label border px-3 py-1.5 transition-colors ${genre?.slug === g.slug ? 'border-paper text-paper' : 'border-line hover:border-line-2'}`}
              >
                {g.name}
              </Link>
            ))}
          </div>
        )}
      </section>

      <section className="mx-auto max-w-[1400px] px-4 sm:px-6 py-10">
        {packs.length === 0 ? (
          <p className="text-muted py-20 text-center">No packs here yet.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {packs.map((pack) => (
              <PackCard key={pack.id} pack={pack} />
            ))}
          </div>
        )}
      </section>
    </>
  )
}
